import React, { useState, useEffect,useRef } from "react";
import Modal from "../modal";
import { getUserInt, ActualizaUser } from "../../services/user";
import { getCargosall } from "../../services/cargo";
import { ErrorContext } from "../../utils/context/error";
import { useValidacionFormulario } from "../../hooks/validacion";

function UserModal({ show, UsuarioI, Tag, handleshow, onGuardado }) {

  const [habilita, setHabilita] = useState(false);
  const [usuarioId, setUsuarioId] = useState(0);
  const [Titulo, setTitulo] = useState("");
  const [cargos, setCargos] = useState([]);
  const { setShowToast, setOpciones } = ErrorContext();
  const [activeTab, setActiveTab] = useState("tab1");
  
  const camposMayusculas = ["Nombre1", "Nombre2", "Apellido1", "Apellido2"];

  const [datas, setDatas] = useState({CodigoUsr:'', 
                                      NumeroNit:'', 
                                      Apellido1:'', 
                                      Apellido2:'',
                                      Nombre1:'',
                                      Nombre2:'',
                                      Direccion:'',
                                      Email:'',
                                      Telefono:'',
                                      Celular:'',
                                      Fax:'',
                                      TarjetaNro:'',
                                      Rol:0,
                                      UsuarioId:0,
                                      CiudadId:'',
                                      NombreCiudad:'',
                                      Tag:Tag,
                                      PersonalId:0,
                                      CargoId:null})
const {validarCampos, limpiarError, claseLabel, claseCampo,} = useValidacionFormulario(datas);
//----------------------------------------------------------------------------------------------------------------------  
  const handleCancel = async () => {
    handleshow(false);
  };

//----------------------------------------------------------------------------------------------------------------------
  const handleAceptar = async () => {
    const esValido = validarCampos(["CodigoUsr","NumeroNit","Nombre1","Apellido1","Rol"]);

    if (!esValido) return;
  
    setHabilita(true);
    setShowToast(false);
    const response = await ActualizaUser(datas);
    if (response) 
      {
        if (response.status === 200) 
         {
           onGuardado(response.data.data); 
           handleshow(false);
           setHabilita(true);
         } 
        else 
         {
           const Mensaje = response.message;
           const opc = { type: "Danger", message: Mensaje, active: true };
           setOpciones(opc);
           setShowToast(true);
           setHabilita(false);
         }
      }
    setHabilita(false);
  };

//----------------------------------------------------------------------------------------------------------------------
const fillCargos = async()=>
  {
    const response = await getCargosall();
    if (response) {
      if (response.status === 200) {
        setCargos(response.data.data ?? []);
      } else {
        const Mensaje = response.message;
        const opc = { type: "Danger", message: Mensaje, active: true };
        setOpciones(opc);
        setShowToast(true);
      }
    }

  } 

//----------------------------------------------------------------------------------------------------------------------
  const fillUsuarioInt = async (UsuarioId) => {
    setShowToast(false);
    fillCargos();
    if (!UsuarioId || UsuarioId == 0)  return;
    const response = await getUserInt(UsuarioId);
    if (response) {
    
      if (response.status === 200) {
        setDatas({
            ...datas,
            CodigoUsr: response.data.data.CodigoUsr, 
            NumeroNit:response.data.data.NumeroNit,  
            Apellido1:response.data.data.Apellido1,
            Apellido2:response.data.data.Apellido2,
            Nombre1:response.data.data.Nombre1,
            Nombre2:response.data.data.Nombre2,
            Direccion:response.data.data.Direccion,
            Email:response.data.data.Email,
            Telefono:response.data.data.Telefono,
            Celular:response.data.data.Celular,
            Fax:response.data.data.Fax,
            TarjetaNro:response.data.data.TarjetaNro,
            Rol:response.data.data.Rol,
            UsuarioId:response.data.data.UsuarioId,
            CiudadId:response.data.data.CiudadId,
            NombreCiudad :response.data.data.NombreCiudad,
            PersonalId :response.data.data.PersonalId ?? 0,
            CargoId :response.data.data.CargoId ?? null,
          });
       // setCargos(response.data.cargo ?? []);
      } else {
        const Mensaje = response.message;
        const opc = { type: "Danger", message: Mensaje, active: true };
        setOpciones(opc);
        setShowToast(true);
      }
    }
  };

//----------------------------------------------------------------------------------------------------------------------
const handleChange = (e) => 
  {
    const { name, value } = e.target;
    setDatas((prev) => ({
      ...prev,
      [name]:
        name === "CargoId"
          ? Number(value)
          : camposMayusculas.includes(name)
            ? value.toUpperCase()
            : value,
    }));
    limpiarError(name);
    setHabilita(false);
  };

//----------------------------------------------------------------------------------------------------------------------
 useEffect(() => {
    if (show) {
        setUsuarioId(UsuarioI);
        fillUsuarioInt(UsuarioI);
        
      if (Tag !== 0) {
        if (Tag === 1) setTitulo("Editar Usuario (" + UsuarioI + ")");
        if (Tag === 2) setTitulo("Eliminar Usuario (" + UsuarioI + ")");
      } else {
        setUsuarioId(0);
        setTitulo("Nuevo Usuario");
      }
    }
  }, [show]);

//----------------------------------------------------------------------------------------------------------------------
  return (
    <>
    <Modal isOpen={show} onClose={()=>handleshow(false)} title={Titulo}>
     <div className="flex lg:w-[29rem] h-full min-h-[33.5rem]">
       <div className="flex flex-col w-full items-center justify-center">
            <div className="w-full max-w-2xl mx-autoc">
                <div className="flex border-b border-stone-200 gap-x-4">
                    <button className={`px-4 py-2 text-sm font-medium flex-1 border-b-2 border-border text-border ${activeTab === "tab1"
                                      && "border-default text-default hover:text-default" }`} onClick={() => setActiveTab("tab1")}>
                      Información General
                    </button>
                    <button className={`px-4 py-2 text-sm font-medium flex-1 border-b-2  border-border text-border ${activeTab === "tab2"
                                  && "font-medium border-default text-default hover:text-default"}`} onClick={() => setActiveTab("tab2")}>
                        Otros Parametros
                    </button>
                </div>
            </div> 
         <form  className="flex w-full flex-col h-full min-h-[33.5rem]" noValidate>
            {activeTab === "tab1" && ( 
             <div className="flex flex-col w-full h-full mt-3">
             <div className="flex flex-row  gap-x-4">
                 <div className="w-full">
                    <label  className={claseLabel("CodigoUsr")}>Código Usuario</label>
                    <input type="text" className={claseCampo("CodigoUsr")} name="CodigoUsr" value={datas.CodigoUsr} onChange={handleChange} placeholder="Código de Ingreso al sistema" autoComplete="nope" disabled={Tag > 0}></input>
                 </div>
                 <div className="w-full">
                    <label className={claseLabel("NumeroNit")}>Identificación</label>
                    <input type="text" className={claseCampo("NumeroNit")} name="NumeroNit" value={datas.NumeroNit} onChange={handleChange} placeholder="Documento de Identidad" autoComplete="nope" disabled={Tag > 0}></input>
                 </div>
              </div>

              <div className="flex flex-row gap-x-4 mt-2">
                 <div className="w-full">
                     <label className={claseLabel("Apellido1")}>Apellidos</label>
                     <div className="w-full flex flex-row gap-x-4">
                        <input type="text" className={claseCampo("Apellido1")} name="Apellido1" value={datas.Apellido1} placeholder="Apellido 1" onChange={handleChange} autoComplete="nope"></input>
                        <input type="text" name="Apellido2" value={datas.Apellido2} placeholder="Apellido 2" onChange={handleChange} autoComplete="nope"></input>
                     </div>
                  </div>      
              </div>   
              <div className="flex flex-row gap-x-4 mt-2">
                 <div className="w-full">
                     <label className={claseLabel("Nombre1")}>Nombre</label>
                     <div className="w-full flex flex-row gap-x-4">
                        <input type="text" className={claseCampo("Nombre1")} name="Nombre1" value={datas.Nombre1} placeholder="Nombre 1" onChange={handleChange} autoComplete="nope"></input>
                        <input type="text" name="Nombre2" value={datas.Nombre2} placeholder="Nombre 2" onChange={handleChange} autoComplete="nope"></input>
                     </div>
                  </div>      
              </div>   

              <div className="flex gap-x-4 mt-2">
                 <div className="w-full">
                    <label>Dirección</label>
                    <input type="text" name="Direccion" value={datas.Direccion} onChange={handleChange} placeholder="Dirección de Residencia" autoComplete="nope"></input>
                 </div>
                 
              </div> 
              <div className="flex  gap-x-4 mt-2">
                 <div className="w-full">
                    <label>Email</label>
                    <input type="text" name="Email" value={datas.Email} onChange={handleChange} placeholder="Correo Electrónico" autoComplete="nope"></input>
                 </div>  
              </div>   

              <div className="flex flex-row gap-x-4 mt-2">
                 <div className="w-full">
                    <label>Teléfono</label>
                    <input type="text" name="Telefono" value={datas.Telefono} onChange={handleChange} placeholder="Número Fijo" autoComplete="nope"></input>
                 </div>
                 <div className="w-full">
                    <label>Fax</label>
                    <input type="text" name="Fax" value={datas.Fax} onChange={handleChange} placeholder="Número Fax" autoComplete="nope"></input>
                 </div>
                 <div className="w-full">
                    <label>Móvil</label>
                    <input type="text" name="Celular" value={datas.Celular} onChange={handleChange} placeholder="Número Celular" autoComplete="nope"></input>
                 </div>
              </div>

              <div className="flex flex-row gap-x-4 mt-2">
                 <div className="w-full">
                    <label>Tarjeta Nro.</label>
                    <input type="text" name="TarjetaNro" value={datas.TarjetaNro} onChange={handleChange} placeholder="Número Tarjeta Profesional" autoComplete="nope"></input>
                 </div>
                 <div className="w-full">
                    <label className={claseLabel("Rol")}>Rol</label>
                    <select id="modulo" name="Rol" className={claseCampo("Rol")} value={datas.Rol} onChange={handleChange} label="Modulo">
                      <option value={0} disabled>Seleccionar un Rol...</option>
                      <option value={1}>Administrador</option>
                      <option value={2}>Usuario del Sistema</option>
                   </select>
                 </div>
              </div>
              </div>   
              )}
              {/* tab 2 */}
              {activeTab === "tab2" && (
                <div className="flex flex-col w-full h-full mt-3">
                  <div className="flex flex-row gap-x-4 mt-2">
                     <div className="w-full">
                        <label>Cargo</label>
                        <select id="cargo" name="CargoId" value={datas.CargoId ?? ""} onChange={handleChange} label="Modulo">
                           <option value="" disabled>Seleccionar un Cargo...</option>
                              {cargos.map((t, index) => (
                                 <option key={index} value={t.CargoId}>
                                     {t.NombreCar}
                                 </option>
                              ))}

                        </select>
                     </div>
                  </div>                  
                  <div className="flex flex-row gap-x-4 mt-2">
                     <div className="w-full">
                        <label>Tipo Personal</label>
                        <select id="modulo" name="PersonalId" value={datas.PersonalId} onChange={handleChange} label="Modulo">
                           <option value={0} disabled>Seleccionar un Tipo Personal...</option>
                           <option value={1}>Médico(a) Especialista</option>
                           <option value={2}>Médico(a) General</option>
                           <option value={3}>Enfermera(o)</option>
                           <option value={4}>Auxiliar de Enfermeria</option>
                           <option value={5}>Otro</option>
                        </select>
                     </div>
                  </div>   
                  
                </div>
              )}
              <div className="flex w-full gap-4 mt-6 justify-end">
                 <button name="Aceptar" className="btnprimary" onClick={handleAceptar} disabled={habilita} type="button">Aceptar</button>
                 <button name="Cancelar" className="" onClick={handleCancel} disabled={habilita} type="button">Cancelar</button>
               </div>                    
          </form> 
       </div> 
     </div>      
    </Modal>
    </>
  );
}
export default UserModal;
